import type { FC, PropsWithChildren } from "react";
import React, { createContext, useContext, useMemo, useState } from "react";
import type { SummaryTabType } from "../../../../../utils/types/SummaryType";
import { useCarConfigSelector } from "../../../../../redux/store";

export const summaryTabVariants: Record<string, SummaryTabType> = {
    overview: "overview",
    cash: "cash",
    finance: "finance",
    insurance: "insurance",
    business: "business",
};

type TabsContextType = {
    openTab?: SummaryTabType;
    setOpenTab?: (newTab: SummaryTabType) => void;
};

const TabsContext = createContext<TabsContextType>({});

export const TabsContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const defaultTab = useCarConfigSelector(
        (state) => state.carConfigSettings.summaryConfig?.defaultTab || summaryTabVariants.overview,
    );
    const [openTab, setOpenTab] = useState<SummaryTabType>(defaultTab);

    const value = useMemo(() => ({ openTab, setOpenTab }), [openTab, setOpenTab]);

    return <TabsContext.Provider value={value}>{children}</TabsContext.Provider>;
};

export const useTabsContext = (): TabsContextType => {
    return useContext<TabsContextType>(TabsContext);
};
